export const scrollToPosition = (position: number): void => {
  const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;

  if (supportsNativeSmoothScroll) {
    window?.scrollTo({
      top: position,
      behavior: 'smooth',
    });
  } else {
    window?.scrollTo(0, position);
  }
};

export const scrollToElement = (
  element: string | Element,
  offsetFromTop: number
): void => {
  const domElement =
    typeof element === 'string' ? document.getElementById(element) : element;
  const elementTop = window.pageYOffset + (domElement?.getBoundingClientRect().top ?? 0);

  scrollToPosition(elementTop - offsetFromTop);
};
